<template>
    <div class="ureaDetail">
        <big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>

        <heading :title="'尿素明细'" :back="true"/>
        <section>
            <div class="numberPlate numberPlate-title">
                货车车牌号：
                <span class="number">{{ info.plateNumber }}</span>
            </div>


            <div class='show-bottom'>
                <div class='show-bottom-title'>申请明细</div>
                <div class='show-bottom-text '>金额(元) / 单价(元/升) = 尿素量(升)</div>


                <div class="item" v-for='consignment in info.recordVoList' :key='consignment.consignmentCode'>
                    <div class="card">
                        <div class="top common">
                            <div class="left">
                                <span class="txt"></span>
                                <span class="num">{{ consignment.projectName }}</span>
                            </div>
                        </div>

                         <div class="bottom common commonbt">
                            <div class="left ">
                                <span class="txt">运单号：</span>
                                <span class="num">{{ consignment.consignmentCode }}</span>
                            </div>
                        </div>

                        <div class="center">
                            <div class="one">
                                <div class="text">尿素量 :</div>
                                <div class="num" v-if="consignment.originalPrice">
                                    {{ parseMoneyFormat(consignment.originalPrice) }}
                                    /
                                    {{ parseMoneyFormat(consignment.projectUreaPrice) }}
                                    =
                                    {{ parseMoneyFormat(consignment.planLiter) }}
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>


                <div>
                    <div class='show-bottom-bottom total-top'>
                        <span class='total total-title'>合计升数:</span>
                        <span class='total'>{{ parseMoneyFormat(info.planLiter) }}(升)</span>
                    </div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>合计金额:</span>
                        <span class='total'>{{ parseMoneyFormat(info.driverPlanMoney) }}(元)</span>
                    </div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>申请时间:</span>
                        <span class='total'>{{ info.createTime }}</span>
                    </div>
                </div>

            </div>


            <div class='show-bottom' v-if="info.writeOffTime">
                <div class='show-bottom-title'>实际明细</div>
                <div class='show-bottom-text '>金额(元) / 单价(元/升) = 尿素量(升)</div>


                <div class="item" v-for='consignment in info.recordVoList' :key='consignment.consignmentCode'>
                    <div class="card">
                        <div class="top common">
                            <div class="left">
                                <span class="txt"></span>
                                <span class="num">{{ consignment.projectName }}</span>
                            </div>
                        </div>
                          <div class="bottom common commonbt">
                            <div class="left ">
                                <span class="txt">运单号：</span>
                                <span class="num">{{ consignment.consignmentCode }}</span>
                            </div>
                        </div>

                        <div class="center">
                            <div class="one">
                                <div class="text">尿素量 :</div>
                                <div class="num">
                                    {{ parseMoneyFormat(consignment.originalPrice) }}
                                    /
                                    {{ parseMoneyFormat(consignment.projectUreaPrice) }}
                                    =
                                    {{ parseMoneyFormat(consignment.actualLiter) }}
                                </div>
                            </div>
                        </div>
                      
                    </div>
                </div>


                <div>
                    <div class='show-bottom-bottom total-top'>
                        <span class='total total-title'>合计升数:</span>
                        <span class='total'>{{ parseMoneyFormat(info.actualLiter) }}(升)</span>
                    </div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>合计金额:</span>
                        <span class='total'>{{ parseMoneyFormat(info.driverActualMoney) }}(元)</span>
                    </div>
                    <div class='show-bottom-bottom'>
                        <span class='total total-title'>核销时间:</span>
                        <span class='total'>{{ info.writeOffTime }}</span>
                    </div>
                </div>

            </div>

            <div class="gap"></div>

            <div>

                <div class="gap"></div>
                <div class="card" v-if="info.writeOffTime">
                    <div class="title" style='margin-left:5vw'>尿素站信息</div>

                    <div style='width:100%'>
                        <div class='show-bottom-bottom'>
                            <span class='total total-title'>尿素站信息</span>
                            <span class='total'>{{info.stationName  }}</span>
                        </div>
                        <div class='show-bottom-bottom'>
                            <span class='total total-title'>核销员：</span>
                            <span class='total'>{{ info.writeOffer }}</span>
                        </div>
                        <div class='show-bottom-bottom'>
                            <span class='total total-title'>设备号：</span>
                            <span class='total'>{{ info.ureaGunName }}</span>
                        </div>
                    </div>
                </div>


                <div class="camera card" v-if="info.writeOffTime">
                    <div class="title">附件展示:</div>
                    <!--        <img v-if="!info.imgList.length" class="camera-img no-img"  src="@/assets/images/camera_upload.png">-->
                    <span v-if="!info.imgList.length" class="no-img">
          无
        </span>
                    <img v-else v-for="item in info.imgList" :key="item.url"
                         class="camera-img" :src="item.url" @click="clickImg($event)">
                </div>
            </div>


        </section>


        <footer v-if="!this.info.history">
            <div class="question" @click="show = true">
                <img src="@/assets/images/logo-question.png" alt=""/>
                <div class="text">疑问</div>
            </div>
            <van-button
                    class="btn"
                    color="linear-gradient(0deg,#FC9C0A, #FEB022)"
                    @click="goDriverConfirm"
            >确认
            </van-button
            >
        </footer>
        <!-- 尿素弹框 -->
        <van-popup
                v-model="show"
                class="popupContent"
                round
                position="bottom"
                :overlay-style="{ backgroundColor: 'rgba(0,0,0,0.3)' }"
        >
            <div class="popupBox">
                <div class="top">请输入备注</div>
                <div class="bottom">
                    <div class="input-box">
            <textarea
                    placeholder="请输入备注"
                    style="resize: none"
                    class="opinion-textarea"
                    v-model="message"
                    rows="2"
            ></textarea>
                    </div>
                    <div class="btn-popup">
                        <van-button
                                plain
                                class="popup-btn"
                                color="#FDAA1A"
                                @click="show = false"
                        >取消
                        </van-button
                        >
                        <van-button
                                class="popup-btn"
                                color="linear-gradient(0deg,#FC9C0A, #FEB022)"
                                @click="driverConfirm"
                        >确定
                        </van-button
                        >
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {Toast, Dialog} from "vant";
    import {driverQuestion, driverConfirm} from "@/api/center/ureaManage";
    import BigImg from "./bigImg";

    export default {
        name: "",
        components: {
            'big-img': BigImg
        },
        props: {},
        data() {
            return {
                show: false,
                message: "",
                info: {},
                fileOne: {
                    img: [],
                },
                fileTwo: {
                    img: [],
                },
                showImg: false,
                imgSrc: ''
            };
        },
        created() {
            this.info = this.$route.query.info;
        },
        mounted() {
        },
        methods: {
            driverConfirm() {
                Toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    loadingType: "spinner",
                });
                driverQuestion({
                    applyId: this.$route.query.id,
                    remark: this.message,
                }).then((res) => {
                    if (res.data.errno === 200) {
                        Toast.clear();
                        this.$toast({
                            message: "操作成功",
                            type: "success",
                            forbidClick: true,
                            duration: 1500,
                            onClose: () => {
                                this.show = false;
                                this.message = "";
                                this.$router.push({
                                    path: "/my",
                                });
                            },
                        });
                    } else {
                        Toast.clear();
                        Toast({
                            message: res.data.msg,
                            duration: 1500,
                        });
                    }
                })
                    .catch((error) => {
                    });
            },
            goDriverConfirm() {
                Dialog.confirm({
                    title: "提示",
                    message: "是否确认",
                })
                    .then(() => {

                        Toast.loading({
                            message: "确认中...",
                            forbidClick: true,
                            loadingType: "spinner",
                        });
                        driverConfirm(this.$route.query.id).then((res) => {
                            if (res.data.errno === 200) {
                                Toast.clear();
                                this.$toast({
                                    message: "操作成功",
                                    type: "success",
                                    forbidClick: true,
                                    duration: 1500,
                                    onClose: () => {
                                        this.$router.push({
                                            path: "/my",
                                            // query: {
                                            //   id: res.data.applyPO.id,
                                            // },
                                        });
                                    },
                                });
                            } else {
                                Toast.clear();
                                Toast({
                                    message: res.data.msg,
                                    duration: 1500,
                                });
                            }
                        });
                    })
                    .catch(() => {
                        // on cancel
                        console.log("cancel");
                    });
            },
            clickImg(e) {
                this.showImg = true;
                // 获取当前图片地址
                this.imgSrc = e.currentTarget.src;
            },
            viewImg() {
                this.showImg = false;
            },
        },

        computed: {},
        watch: {},
    };
</script>
<style lang="less" scoped>
    .ureaDetail {
        width: 100vw;
        height: 100vh;
    }

    section {
        height: calc(100vh - 2.3rem /* 115/50 */);
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;

        .numberPlate {
            width: 92%;
            font-size: 0.32rem /* 16/50 */;
            font-family: PingFang SC;
            font-weight: 500;
            color: #7E7E7E;
            margin-top: 0.4rem /* 20/50 */;

            .number {
                color: #333333;
            }
        }

        .card {
            width: 100%;

            .title {
                font-size: 0.32rem /* 16/50 */;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                margin-top: 0.4rem /* 20/50 */;
            }

            .item {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                // font-size: 0.32rem /* 16/50 */;
                font-family: PingFang SC;
                color: #7E7E7E;
                padding: 0.4rem /* 20/50 */ 0;
                box-sizing: border-box;

                .text {
                    font-size: 0.27rem;
                    font-weight: 700;
                    color: #7e7e7e;
                }

                .num {

                }

                .green {
                    font-size: 0.36rem /* 18/50 */;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #1AD26C;
                }
            }

            .border {
                border-bottom: 1px solid #efefef;
            }
        }

        .gap {
            width: 100%;
            height: 0.2rem /* 10/50 */;
            background: #F2F2F2;
        }

    }

    footer {
        position: fixed;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1.3rem /* 65/50 */;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(28, 35, 78, 0.1);
        box-sizing: border-box;
        padding: 0 0.3rem /* 15/50 */;

        .question {
            width: 13%;
            height: 0.9rem /* 45/50 */;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            > img {
                width: 0.42rem /* 21/50 */;
            }

            .text {
                font-size: 0.26rem /* 13/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                color: #AEAEAE;
            }
        }

        .btn {
            width: 83%;
            height: 0.9rem /* 45/50 */;
            box-shadow: 0px 0px 10px 0px rgba(7, 63, 53, 0.1);
            border-radius: 5px;
            font-size: 0.36rem /* 18/50 */;
            font-family: PingFang SC;
            font-weight: 500;
        }
    }

    // 尿素弹框
    .popupBox {
        width: 100vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 0.3rem /* 15/50 */;

        .top {
            width: 100%;
            font-size: 0.32rem /* 16/50 */;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            margin-bottom: 0.4rem /* 20/50 */;
        }

        .bottom {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            box-sizing: border-box;

            .input-box {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                padding: 0.28rem /* 14/50 */ 0;
                margin: 0 0 0.3rem /* 15/50 */;
                background: #F2F2F2;
                border: 1px solid #EEEEEE;
                border-radius: 5px;
            }

            .opinion-textarea {
                width: 90%;
                font-size: 0.36rem /* 18/50 */;
                font-family: PingFang SC;
                font-weight: 500;
                background: #F2F2F2;
            }

            ::-webkit-input-placeholder {
                color: #AEAEAE;
            }

            :-moz-placeholder {
                /* Firefox 18- */
                color: #AEAEAE;
            }

            ::-moz-placeholder {
                /* Firefox 19+ */
                color: #AEAEAE;
            }

            :-ms-input-placeholder {
                color: #AEAEAE;
            }

            .kind {
                width: 100%;
                font-size: 0.28rem /* 14/50 */;
                font-family: PingFang SC;
                font-weight: 400;
                color: #7E7E7E;
                margin-bottom: 0.6rem /* 30/50 */;

                > span {
                    font-weight: bold;
                    color: #28347C;
                }
            }

            .btn-popup {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .popup-btn {
                width: 40%;
                height: 0.9rem /* 45/50 */;
                box-shadow: 0px 0px 10px 0px rgba(7, 63, 53, 0.1);
                border-radius: 5px;
                font-size: 0.36rem /* 18/50 */;
                font-family: PingFang SC;
                font-weight: 500;
            }
        }
    }

    .camera {
        padding: 5vw 5vw;
        width: 90vw !important;

        .camera-img {
            padding: 5vw;
            width: 80vw;
            height: 80vw;
        }

        .no-img {
            padding: 5vw;
            display: block;
        }
    }

    .show-bottom-main {
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        flex-direction: column;
        text-align: center;
        // background-color: red;
        margin: .2rem 0;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
            display: none;
        }

        .show-list {
            display: flex;
            margin: .2rem 0;

            div {
                min-width: 2rem;
                padding: 0 .2rem;
            }

            .show-first {
                min-width: 4rem;
                padding-right: .2rem;
            }
        }


    }

    .main {
        width: 95%;
    }

    .item {
        width: 100%;
        margin: .3rem 0;

        .title {
            font-size: 0.32rem /* 16/50 */;
            font-family: PingFang SC;
            font-weight: bold;
            color: #ff9e02;
            margin: 0.3rem /* 15/50 */ 0;
        }

        .card {
            // background: #ffffff;
            width: 96%;
            margin-left: 2%;
            /*box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);*/
            /*border-radius: 0.2rem !* 10/50 *!;*/
            /*border: 1px solid #e1e1e1;*/

            .top {
                border-top: 3px solid #ccc;
            }

            .common {
                display: flex;
                justify-content: space-between;
                padding: 0.26rem /* 13/50 */;
                padding-top: 0.1rem;

                font-size: 0.28rem /* 14/50 */;
                font-family: PingFang SC;
                font-weight: 700;
                color: #7e7e7e;

                .left-text {
                    width: 50%;
                    overflow: hidden;
                }

                .txt {
                    font-weight: 400;
                    color: #7e7e7e;
                }

                .yellow {
                    color: rgb(254, 176, 34);
                }

                .black {
                    // color: #28347C;
                    color: #333333;
                }

                .red {
                    color: #dd191d;
                }

                .blue {
                    color: #455ede;
                }

                .grey {
                    color: #aeaeae;
                }
            }

            .commonbt {
                padding-top: 0;
                padding-bottom: 0;
                /*margin-top: -.2rem;*/
            }

            .center {
                display: flex;
                justify-content: space-between;
                padding: 0.26rem /* 13/50 */;

                .one {
                    font-size: 0.28rem /* 16/50 */;
                    font-family: PingFang SC;
                    font-weight: bold;
                    /*color: #333333;*/
                    /*width: 33%;*/

                    .num {
                        /*margin-bottom: 0.26rem !* 13/50 *!;*/
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .text {
                        font-size: 0.28rem /* 14/50 */;
                        font-family: PingFang SC;
                        font-weight: 400;
                        color: #7e7e7e;
                    }
                }
            }

            /*.bottom {*/
            /*    border-top: 1px solid #efefef;*/
            /*}*/
        }
    }

    .show-bottom-bottom {
        display: flex;
        justify-content: space-between;
        padding: .26rem 5%;
        font-weight: 700;
    }


    .right-text {
        width: 50%;
    }

    .one {
        /*text-align: right;*/
        display: flex;
        justify-content: space-between;
        width: 100%;
        /*text-align: center;*/
    }

    .center {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .show-bottom {
        margin-top: .3rem;
        width: 100vw;
    }

    .show-bottom-text,
    .show-bottom-title {
        padding-left: 5%;
        text-align: left;
    }

    .show-bottom-title {
        height: .5rem;
        font-size: .36rem;
        font-weight: 600;
    }

    .show-bottom-text {
        color: #7e7e7e;
        font-size: .32rem;
    }

    .numberPlate-title {
        text-align: center;
        font-size: .5rem;
    }

    .total-title {
        color: #7e7e7e;
    }
    .total{
        font-size: .32rem;
    }
    .total-top{
  border-top: 3px solid #ccc;
}
</style>
